import { setCookie, getCookie } from 'utils/cookie';
import { hide as hideOverlay, show as showOverlay, create as createOverlay } from 'utils/overlay';

class Geolocation {
  constructor(node) {
    this.element = node;
    this.countryCode = null;

    this.inner = node.querySelector('[data-inner]');
    this.languages = node.querySelector('[data-languages]');

    this.sites = window.sites;
    this.locale = window.theme.locale;
    this.cookieName = 'geolocation';

    createOverlay(this.element);

    this.clickEvent = this.clickEvent.bind(this);
    this.keydownEvent = this.keydownEvent.bind(this);
    this.addEventListeners = this.addEventListeners.bind(this);

    this.init.call(this);
  }

  init() {
    const geoCookie = getCookie(this.cookieName);
    if (geoCookie) return;

    if (window.CookieInformation) {
      window.addEventListener('CookieInformationConsentGiven', () => {
        if (window.CookieInformation.getConsentGivenFor('cookie_cat_statistic')) {
          this.apiFetch.call(this);
        }
      });
    } else {
      this.apiFetch.call(this);
    }
  }

  buildItems() {
    const renderFlag = (flag) => (`<span class="w-7 h-7 mr-3 rounded-full">${flag}</span>`);

    const renderSite = (site) => {
      const {
        flag,
        label,
        url,
        prettyUrl,
      } = site;

      return `
        <a class="flex flex-wrap items-center py-2 px-3 border border-grey my-1 hover:bg-black hover:text-white" href="${prettyUrl ?? `https://${url}`}">
          ${renderFlag(flag)}
          <p>${label}</p>
        </a>
      `;
    };

    const fallbackLanguage = Object.entries(this.sites).filter((site) => site[1].code === 'en');
    const related = Object.entries(this.sites).filter((site) => site[1].code === this.countryCode);

    if (related.length) {
      if (related[0][1].locale !== window.theme.locale) {
        this.languages.innerHTML = renderSite(related[0][1]);
      } else {
        this.close();
      }
    } else {
      this.languages.innerHTML = renderSite(fallbackLanguage[0][1]);
    }
  }

  addEventListeners() {
    document.addEventListener('click', this.clickEvent);
    document.addEventListener('keydown', this.keydownEvent);
  }

  removeEventListeners() {
    document.removeEventListener('click', this.clickEvent);
    document.removeEventListener('keydown', this.keydownEvent);
  }

  clickEvent(event) {
    if (!this.inner.contains(event.target)) {
      event.stopPropagation();
      this.close();
    }

    if (event.target.hasAttribute('data-close')) {
      event.stopPropagation();
      this.close();
    }
  }

  keydownEvent(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  open() {
    this.element.classList.add('is-active');
    this.element.setAttribute('aria-hidden', false);
    this.element.hidden = false;
    showOverlay(this.element);

    this.buildItems();
    this.addEventListeners();
  }

  close() {
    this.element.classList.remove('is-active');
    this.element.setAttribute('aria-hidden', true);
    this.element.hidden = true;
    hideOverlay(this.element);

    setCookie(this.cookieName, true, 30);

    this.removeEventListeners();
  }

  async apiFetch() {
    const response = await fetch('https://get.geojs.io/v1/ip/country.json');
    const data = await response.json();

    this.countryCode = data.country.toLowerCase();

    if (this.countryCode !== window.theme.locale) this.open();
    else this.close();
  }
}

export default (node) => new Geolocation(node);
